import React from 'react';
export function CTASection() {
  return <div className="text-center bg-brand-dark text-white rounded-2xl p-12" data-id="element-87">
      <h2 className="text-3xl font-bold mb-6" data-id="element-88">
        Ready to upgrade your equipment?
      </h2>
      <a href="/#kits" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-89">
        View The ForceX Lineup
      </a>
    </div>;
}